import create from "zustand";

interface OFVNotification {
  visible?: boolean;
  title?: string;
  message?: string;
  isError: boolean;
  duration?: number;
}

interface GlobalState {
  notification: OFVNotification;
  loading?: boolean;
  showNotification: (notification: OFVNotification) => void;
  hideNotification: (isError: boolean) => void;
  showLoading: () => void;
  hideLoading: () => void;
}

export const useGlobalStore = create<GlobalState>((set) => ({
  // initial state
  notification: {
    visible: false,
    isError: false,
  },

  // methods for manipulating state
  showNotification: (notification: OFVNotification) => {
    const isError = notification.isError;
    set((state) => ({
      ...state,
      notification: {
        visible: true,
        title: notification.title,
        message: notification.message,
        isError: isError,
      },
    }));

    if (notification.duration !== 0) {
      setTimeout(() => {
        set((state) => ({
          ...state,
          notification: { visible: false, isError: isError },
        }));
      }, notification.duration || 5000);
    }
  },
  hideNotification: (isError: boolean) => {
    set((state) => ({
      ...state,
      notification: { visible: false, isError: isError },
    }));
  },
  showLoading: () => {
    set((state) => ({
      ...state,
      loading: true,
    }));
  },
  hideLoading: () => {
    set((state) => ({
      ...state,
      loading: false,
    }));
  },
}));
